import React from 'react';

interface PriceHoldIconProps {
  className?: string;
}

const PriceHoldIcon: React.FC<PriceHoldIconProps> = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M5.33337 7.60078C5.33337 8.11411 5.73337 8.53412 6.22004 8.53412H7.22004C7.64671 8.53412 7.99337 8.16745 7.99337 7.72078C7.99337 7.23411 7.78004 7.06078 7.46671 6.94745L5.86671 6.38745C5.54671 6.27411 5.33337 6.10078 5.33337 5.61411C5.33337 5.16745 5.68004 4.80078 6.10671 4.80078H7.10671C7.60004 4.80745 8.00004 5.22078 8.00004 5.73412" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.66663 8.56641V9.05974" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.66663 4.27344V4.79344" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M6.66004 11.9873C3.7182 11.9873 1.33337 9.60249 1.33337 6.66065C1.33337 3.71881 3.7182 1.33398 6.66004 1.33398C9.60188 1.33398 11.9867 3.71881 11.9867 6.66065C11.9867 9.60249 9.60188 11.9873 6.66004 11.9873Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.65332 13.2527C9.25332 14.0993 10.2333 14.6527 11.3533 14.6527C13.1733 14.6527 14.6533 13.1727 14.6533 11.3527C14.6533 10.246 14.1067 9.26602 13.2733 8.66602" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default PriceHoldIcon;


